import { useAiCreateReportFeature, useShowAiDebug } from '../../../utils/hooks';
import useBuilderSelector from '../../../redux/selectorHooks/useBuilderSelector';
import { builderToggleShowLumosPrompt } from '../../../redux/slices/oldBuilder';
import { useAppDispatch } from '../../../redux/hooks';
import { useBootstrapSelector } from '../../../redux/selectorHooks';

const useShowCloseLlmPrompt = (
  // TODO temp param, to be removed once the CSE-only limit is lifted
  showToNonCse: boolean = false,
) => {
  const dispatch = useAppDispatch();
  const isAiCreateReportFeatureEnabled = useAiCreateReportFeature();
  const { isPromptVisible } = useBuilderSelector('llmContext');
  const llmApiEnabled = useBootstrapSelector('llmApiEnabled');

  // TODO XXX the "AiDebug" feature flag limits the exposure of this to Support Engineer Admins.
  const isAiDebugFeatureEnabled = useShowAiDebug();
  const visibleToNonCse = showToNonCse || isAiDebugFeatureEnabled;

  const showLlmPrompt =
    visibleToNonCse &&
    isAiCreateReportFeatureEnabled &&
    isPromptVisible &&
    llmApiEnabled;

  const handleCloseLlmPrompt = () => {
    dispatch(builderToggleShowLumosPrompt(false));
  };
  return { showLlmPrompt, handleCloseLlmPrompt };
};

export default useShowCloseLlmPrompt;
